import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import App from './App.vue';
import router from './router';
import i18n from './i18n';

Vue.config.productionTip = false;

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0189d0', // BLUE
        secondary: '#F59B32', // ORANGE
        tertiary: '#234EA2', // STRONG_BLUE
        text: '#676767', // GRAY
      },
    },
    options: {
      customProperties: true,
    },
  },
});

new Vue({
  router,
  i18n,
  vuetify,
  render(h) { return h(App); },
}).$mount('#app');
